import { render, staticRenderFns } from "./theLoader.vue?vue&type=template&id=2a60b966&scoped=true&"
import script from "./theLoader.vue?vue&type=script&lang=js&"
export * from "./theLoader.vue?vue&type=script&lang=js&"
import style0 from "./theLoader.vue?vue&type=style&index=0&id=2a60b966&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a60b966",
  null
  
)

export default component.exports